<template>
	<div>
		<el-card shadow="never">
			<div>
                <span v-show="!formData.imagesUrl || formData.imagesUrl.length == 0">无</span>
                <el-image v-for="imgUrl in formData.imagesUrl" class="imageItem" :preview-src-list="[imgUrl]" :key="imgUrl" :src="imgUrl" referrerPolicy="no-referrer">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                    </div>
                </el-image>
			</div>
		</el-card>
	</div>
</template>
<script>
import dlgForm from "@/mixin/dlgForm";

export default {
	name: "ImageViewDlg",
	mixins: [dlgForm],
	data() {
		return {
			
		};
	},
	methods: {
		
	},
};
</script>
<style scoped>
.imageItem {
    display: inherit;
    overflow: hidden;
    width: 100%;
    height: 150px;
    margin-right: 10px
}
</style>